import React from 'react'
import {
    ContentButton,
    ContentForm,
    ContentInput,
    SectionSAndF,
    SectionTitle,
} from './styles'
import { FiltForm } from 'src/components/common/Form'
import { useFormik } from 'formik'
import { subscribe } from 'src/api/authOtp'
import { Props, useValidationSchema } from 'src/components/layout/Main/Footer'
import { useTranslations } from 'src/provider/LocaleProvider'

export const Subscribe = () => {
    const t = useTranslations()
    const ValidationSchema = useValidationSchema()

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: ValidationSchema,
        onSubmit: (values, { resetForm }) =>
            handleSubmitForm({ values, resetForm }),
    })
    async function handleSubmitForm({ values, resetForm }: Props) {
        try {
            const resp = await subscribe(values)
            if (resp.status === 201) {
                resetForm()
            }
        } catch (e) {
            console.error(e)
        }
    }
    return (
        <SectionSAndF marginTop={'medium'}>
            <SectionTitle variant={'h2'} fontSize={'medium'} fontWeight={600}>
                {t('blog.recentBlog.getLatestUpdates')}
            </SectionTitle>
            <ContentForm onSubmit={formik.handleSubmit}>
                <ContentInput marginTop={'xxxsmall'}>
                    <FiltForm
                        id={'email'}
                        title={t('fields.email.labelCompany')}
                        errors={formik.errors.email}
                        touched={formik.touched.email}
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                </ContentInput>
                <ContentButton type="submit">
                    {t('subscription.title')}
                </ContentButton>
            </ContentForm>
        </SectionSAndF>
    )
}
